import { validateEmail } from '../../util';

export type FormErrors = Partial<Record<string, string>>;

type Options = {
  requiredMessage: string,
};

// activeProducts is absent on purpose: an organization needs a product, and add-ons are not one.
const optionalFields = (formData: Record<string, unknown>) => [
  'isActive',
  'preApproveRecommendedSuppliers',
  'addOns',
  'expiry',
  'customerType',
  'credibility.syna.user', 'credibility.syna.number',
  'credibility.creditsafe.user', 'credibility.creditsafe.password',
  'credibility.tic.key', 'credibility.tic.email',
  'microsoftTenantId',
  'emailDomain',
  'logo',
  'emailProvider',
  'emailSuffixes',
  'onePlatformCompanyId',
  ...(formData.nextProjectIntegrationIsActive ? [] : ['nextProjectAuthToken']),
  'nextProjectIntegrationIsActive',
  'nextProjectSettings',
  'massMessaging',
  'invoiceEmail',
  'invoiceRef',
  'salesOrgContract',
];

export const organizationFormErrors = (
  formData: Record<string, unknown>,
  { requiredMessage }: Options,
): FormErrors => {
  const optional = optionalFields(formData);
  const errors: FormErrors = {};
  Object.entries(formData).forEach(([key, value]) => {
    if ((key === 'invoiceEmail' || key === 'email') && value) {
      const errorMessage = validateEmail(value);
      if (errorMessage) errors[key] = errorMessage;
    } else if (!optional.includes(key) && (!value || (Array.isArray(value) && !value.length))) {
      errors[key] = requiredMessage;
    }
  });
  return errors;
};
